export const termAndConditions = {
  policyTitle: "Terms and Conditions",
  description:
    "Welcome to Skill Surf! These Terms and Conditions govern your use of our online courses and services. By enrolling in any of our courses or using our website, you agree to abide by the following terms.",
  subContent: [
    {
      policySubTitle: "ENROLMENT AGREEMENT ",
      policyDescription: [
        {
          description:
            "By accepting the following terms and conditions, the participant agrees to pay the course fees for the course using the payment method selected on the enrolment form in the enrolment email he/she receives after registration. The participant accepts that he/she is required to pay the full amount of the course fees unless specific permission has been otherwise obtained from the course supervisors.",
        },
      ],
    },
    {
      policySubTitle: "COURSE ENROLLMENT",
      policyDescription: [
        {
          description: `Course enrolment is complete when the participant has been issued a username/password for online course access/or sent course materials via another method; course fees are non-transferable to other students, unless specific permission has been otherwise obtained from the course supervisors. <span style="text-decoration:underline"> A free-of-charge first session will be provided before the beginning of each course for all registrants to make a decision on whether to enroll in this course by paying the fees and be eligible for the certificate.  </span>`,
        },
        {
          description: `
    <span style="color:red;">NOTE: </span> 
    If you choose to enroll using a discounted pricing (40% OFF) as a student/undergraduate, then
    <span style="text-decoration:underline;">please send your proof of studentship verification (eg: student ID card via your official student email address) to<a href="mailto:skillsurfedu@gmail.com">skillsurfedu@gmail.com</a>.</span>
    Please be mindful to submit true and accurate information about your status, as false information will risk your eligibility for the certificate.
  `,
        },
      ],
    },
    {
      policySubTitle: "CONFIDENTIALITY AND PRIVACY POLICY",
      policyDescription: [
        {
          description:
            "Skill Surf will make reasonable efforts to keep any confidential information that we have about you secure and to ensure that any of our employees or agents who have access to information about you do not make any unauthorized use, modification, reproduction or disclosure of that information. We will only disclose information that we have about you: to the extent specifically required by law; or for the purposes of this agreement (including disclosing information in connection with any query or claim), Information provided by you is confidential and will not be divulged to any third party.",
        },
      ],
    },
    {
      policySubTitle: "COURSE MATERIALS, ACCESS AND ASSESSMENT",
      policyDescription: [
        {
          description: `
    All course materials are supplied in an online platform unless otherwise stated in the course description and are available for viewing online; the content of the online course materials, including copyright and all other such intellectual property rights contained therein, remains the property of Skill Surf. You <b>may not reproduce</b> any part of the online course materials <b>without the prior written consent</b> of Skill Surf. Duration of access to the course material will extend to at least 1 year following the course start date.
  `,
        },
      ],
    },
    {
      policySubTitle: "COURSE WITHDRAWAL AND REFUNDS ",
      policyDescription: [
        {
          description:
            "Skill Surf is not required to provide a refund if you change your mind about the course after you pay the enrollment fee. However, while course fees are non-refundable, students may have extenuating circumstances that prevent them from undertaking their course; where evidence can be successfully provided to support the participant’s circumstances, course fees may be refunded or partially refunded with the approval of the course supervisor",
        },
      ],
    },
    {
      policySubTitle: "CERTIFICATE OF COMPLETION",
      policyDescription: [
        {
          description:
            "Skill Surf provides certificates of completion for each successful course participant. Participants will NOT be monitored on attendance and must have between 75-100% (eg:- 3 or 4 out of 4) completion (submission of correct requirements) of assignments/homework to be eligible for the certificates, and the completion of assignments will be tracked through the online platform. The percentage for passing will be determined by the course supervisors. No final exams will be provided for assessing eligibility for the completion certificate. Assignments have been designed such that they can be completed without any dependence on the course hardware.",
        },
      ],
    },
    {
      policySubTitle: "RE-SCHEDULING OF CLASSES",
      policyDescription: [
        {
          description: `
    Unavoidable circumstances of resource persons may cause the cancellation of scheduled sessions, and, in such situations, the participants will be notified about the rescheduled dates via email or the official messaging group. 
    <span style="text-decoration:underline;">Please be sure to check for updates on Friday night every week during the course timeline.</span>
  `,
        },
      ],
    },
  ],
  active: "terms-and-conditions",
};
